import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromInvoice from '../../core/reducers/invoice.reducer';
import * as actionInvoice from '../../core/actions/invoice.actions';
import { Pagination } from '../../shared/models/pagination';
import { LazyLoadEvent } from 'primeng/api';
@Component({
  selector: 'app-facture-sortie',
  templateUrl: './facture-sortie.component.html',
  styleUrls: ['./facture-sortie.component.scss']
})
export class FactureSortieComponent implements OnInit {
  invoices = [
  ];
  pagination: Pagination;
  lastPagination: string = '';
 

  public statusOptions = [
    {label: 'Projet', value: 'draft'},
    {label: 'Validée', value: 'validated'},
    {label: 'Payée', value: 'paid'},
  ];
  public peppolStatusOptions = [
    {label: 'Projet', value: 'CREATED'},
    {label: 'Envoyée', value: 'SENT'},
    {label: 'Délivrée', value: 'DELIVERED'},
  ];
  constructor(private store: Store<any>) { }

	statusText(s: any): string {
    if (!s.peppol_status) {
      return '';
    }
		switch(s.peppol_status.toLowerCase()) {
			case 'sent':
				return 'Envoyé';
			case 'delivered':
				return 'Délivré';
			case 'created':
				return 'Créé';
			default:
				return s;
		}
  }
  ngOnInit() {
    this.store.select(fromInvoice.selectInvoices).subscribe(st => {this.invoices = st;});
    this.store.select(fromInvoice.selectInvoicePagination).subscribe(c => {console.log(c); this.pagination = c;});

  }
  loadLazy(event: LazyLoadEvent) {        
    if (JSON.stringify(event) !== this.lastPagination ) {
      this.store.dispatch(new actionInvoice.LoadInvoicesAction(event.sortField,event.sortOrder, event.filters, event.first, event.rows));
      console.log('load lazy', event);
      this.lastPagination = JSON.stringify(event);    
    }        
  }  
  addInvoice() {
  	console.log('add invoice');

    this.store.dispatch(new actionInvoice.AddInvoiceAction());
  }
  openInvoice(id) {
     this.store.dispatch(new actionInvoice.OpenTabAction(id)); 
  }
}
